Alpine.data('alpine_item_list', () => ({
  isItemListLoading: false,

  async removeListItem(listIdentifier, sku, callback) {
    this.isItemListLoading = true;

    await window.axios.delete('/account/item-lists/' + listIdentifier + '/' + sku)
      .then(response => {
        if(typeof callback === 'function') {
          callback(response);
        }
      })
      .catch(error => {
        alert('There was a problem deleting this list item.');
      })
      .finally(() => this.isItemListLoading = false);
  },
}));
